import React, { useLayoutEffect, useMemo } from 'react';

import { closeSnackbar, SnackbarProvider, useSnackbar } from 'notistack';

import ScreenMessageList from './ScreenMessageList';
import { useThemeSwitcher } from '@gogame/components';

const anchorOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
};

class MessageProvider extends SnackbarProvider {
  static defaultProps = {
    ...SnackbarProvider.defaultProps,
    dense: true,
    hideIconVariant: true,
    maxSnack: 10,
    anchorOrigin: anchorOrigin,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      ...this.state,
      contextValue: {
        ...this.state.contextValue,
        updateSnackbar: this.updateSnackbar,
      },
    };
  }

  updateSnackbar = (key, message, options) => {
    this.setState((state) => {
      return {
        ...state,
        snacks: state.snacks.map((snack) => {
          if (snack.key === key || snack.id === key) {
            return {
              ...snack,
              ...options,
              message: message,
            };
          }
          return snack;
        }),
      };
    });
  };
}
const ThemeSwitcherControl = ({ children }) => {
  const { activeThemeId } = useThemeSwitcher();
  const { closeSnackbar } = useSnackbar();

  useLayoutEffect(() => {
    closeSnackbar();
  }, [activeThemeId]);

  return children;
};

const StyleMessageProvider = React.forwardRef(({ children, ...props }, ref) => {
  return (
    <MessageProvider
      ref={ref}
      {...props}
      myCustomVariant={true}
      Components={{
        multiple: ScreenMessageList,
      }}
    >
      <ThemeSwitcherControl>{children}</ThemeSwitcherControl>
    </MessageProvider>
  );
});

export default StyleMessageProvider;
